import React from "react";
import { TeamTable } from "./TeamTable";
import { TableTabs } from "@/components/DataTable/TableTabs";
import { useTranslation } from "react-i18next";
import { useOrg } from "@/hooks/useOrg";
import { InviteTable } from "./InviteTable";
import { PageTitle } from "@/components/PageTitle";

export const TeamManagementOverview = () => {
  const { t } = useTranslation();
  const { org } = useOrg();

  return (
    <div>
      <PageTitle
        title={t("teamManagement.title", { organization: org?.name })}
        className="border-b"
      />
      <section className="p-6">
        <TableTabs
          activeTab={0}
          className="rounded-lg border"
          tabs={[
            {
              label: t("teamManagement.table.teammates.title"),
              children: <TeamTable />,
            },
            {
              label: t("teamManagement.table.invited.title"),
              children: <InviteTable />,
            },
          ]}
        />
      </section>
    </div>
  );
};
